// controller
import { splitNumber } from "../../../features/splitNumber/splitNumber";
import useGetData from "../../../hook/getData";
import { GetOrders } from "../../../services/panel/orders/getOrders";

const Orders = () => {
    const { data: orders } = useGetData(['orders'], GetOrders)
    return (
        <>
            <div className="card card-body shadow border-1 rounded rounded-4">
                <div className="rounded box-site rounded-4 d-flex justify-content-between align-items-center py-3 mb-0">
                    <span>سفارشات</span>
                </div>
                <div className="table-responsive mt-4">
                    <table className="table table-bordered text-center font-medium align-middle">
                        <thead>
                            <tr>
                                <th style={{ backgroundColor: 'rgb(245, 245, 245)' }}>ردیف</th>
                                <th style={{ backgroundColor: 'rgb(245, 245, 245)' }}>توضیحات</th>
                                <th style={{ backgroundColor: 'rgb(245, 245, 245)' }}>محصولات</th>
                                <th style={{ backgroundColor: 'rgb(245, 245, 245)' }}>هزینه پیک</th>
                                <th style={{ backgroundColor: 'rgb(245, 245, 245)' }}>هزینه کل</th>
                                <th style={{ backgroundColor: 'rgb(245, 245, 245)' }}>وضعیت</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orders?.orders.map((order: any, index: number) => (
                                <tr key={index + 'order'}>
                                    <td>
                                        {index + 1}
                                    </td>
                                    <td>
                                        {order.decoration ? order.decoration : 'فاقد توضیحات'}
                                    </td>
                                    <td>
                                        {order?.items?.map((item: any) => (
                                            <p className="text-start">
                                                {item.quantity}
                                                عدد
                                                {item.product.name}
                                            </p>
                                        ))}
                                    </td>
                                    <td>
                                        {splitNumber(order.delivery_amount)}
                                    </td>
                                    <td>
                                        {splitNumber(order.total_amount)}
                                    </td>
                                    <td className="fw-bold">
                                        {order.status}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default Orders;
